// ── Debug Store ────────────────────────────────────────────────────────────────
// In-memory circular buffer of HTTP calls. Only active in DEV builds.
// Components subscribe via subscribeDebug() to receive push notifications.

export interface DebugEntry {
  id:           string;
  timestamp:    number;
  method:       string;
  service:      string;
  path:         string;
  url:          string;
  status:       number | null;   // null = network/CORS error
  durationMs:   number;
  requestBody:  unknown;
  responseBody: unknown;
  isError:      boolean;
}

const MAX_ENTRIES = 100;
let entries: DebugEntry[] = [];
const listeners = new Set<() => void>();

export function pushDebugEntry(entry: DebugEntry): void {
  entries = [entry, ...entries].slice(0, MAX_ENTRIES);
  listeners.forEach(fn => fn());
}

export function clearDebugEntries(): void {
  entries = [];
  listeners.forEach(fn => fn());
}

export function getDebugEntries(): readonly DebugEntry[] {
  return entries;
}

/** Returns an unsubscribe function. */
export function subscribeDebug(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
